import angular from 'angular';

export const ApiVersionFactoryModule = angular.module('acme.common.factory.apiVersion', [])
.factory('ApiVersionFactory', [function() {


  function ApiVersion(config) {
    if (config) {
      this.init(config);
    }
  }

  ApiVersion.prototype = {

    constructor: ApiVersion,

    url: '',
    token: false,
    version: false,

    init: function(config) {

      var r = true;

      this.reset();

      if (config.hasOwnProperty('url')) {

        this.setUrl(config.url);


        if (config.hasOwnProperty('token')) {
          this.setToken(config.token);
        }

        if (config.hasOwnProperty('version')) {

          this.setVersion(config.version);

          r = this.use(this.version);

        }

      }else{
        r = false;
      }

      return r;

    },

    reset: function() {
      this.url = '';
      this.token = false;
    },

    setUrl: function(url) {
      this.url = url;
    },

    setToken: function(token) {
      this.token = token;
    },

    setVersion: function(version) {
      this.version = version;
    },

    use: function(version) {

      var regex = /\/v\d+[(\.\d)]?\/?/;

      if (this.token) {
        regex = new RegExp("\/" + this.token + "?\/?");
        if (!regex.test(this.url)) {
          console.warn('Token: ' + this.token + ' not found in: ' + this.url);
        }
      }

      this.url = this.url.replace(regex, '/' + version + '/');

      return this.url;

    }

  };

  return ApiVersion;

}]).name;